module.exports = __webpack_public_path__ + "static/img/sjhc.ebb12137.png";